export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const SET_ALL_SUBITEMS_DATA = 'SET_ALL_SUBITEMS_DATA';
export const THREE_COLUMN_LAYOUT = 'THREE_COLUMN_LAYOUT';
export const THREE_COLUMN_TITLE_LAYOUT = 'THREE_COLUMN_TITLE_LAYOUT';
export const THREE_COLUMN_ALL_TITLE_LAYOUT = 'THREE_COLUMN_ALL_TITLE_LAYOUT';
export const SET_PRODUCTS_JSON_DATA = 'SET_PRODUCTS_JSON_DATA';
export const SET_REDIRECT_PAGE_ID = 'SET_REDIRECT_PAGE_ID';
